import {
  IntermediateAndFinishedProductsClassificationInputNames,
  MaterialType
} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {LONG_COLUMN_WIDTH} from '@settings/modules/common/consts'

const fields = [
  {key: IntermediateAndFinishedProductsClassificationInputNames.Selection},
  {key: IntermediateAndFinishedProductsClassificationInputNames.Category},
  {
    key: IntermediateAndFinishedProductsClassificationInputNames.MethodOfFinenessDetermination,
    minWidth: LONG_COLUMN_WIDTH
  },
  {
    key: IntermediateAndFinishedProductsClassificationInputNames.IntermediateMillProduct,
    minWidth: LONG_COLUMN_WIDTH
  },
  {
    key: IntermediateAndFinishedProductsClassificationInputNames.ReferenceMeshSizeForResidue,
    minWidth: LONG_COLUMN_WIDTH
  }
]

export const IntermediateAndFinishedProductsClassificationHeader = () => {
  return (
    <ClassificationHeaderCells
      fields={fields}
      materialType={MaterialType.IntermediateAndFinishedProducts}
    />
  )
}
